import * as React from "react";
import { useTranslation } from "react-i18next";
import Input from "components/bootstrap/Input";
const VALUE_TITLES = {
  range: "time_range.set_range_value",
  from: "time_range.set_from_value",
  to: "time_range.set_to_value"
};
const RelativeRangeValueInput = React.memo(({ fieldName, unsetRange, value, onChange, disabled, error }) => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `relative-timerange-${fieldName}-value`,
      name: `relative-timerange-${fieldName}-value`,
      disabled: disabled || unsetRange,
      type: "number",
      min: "1",
      value: value === null ? "" : value,
      className: "mousetrap",
      title: t(VALUE_TITLES[fieldName]),
      onChange,
      bsStyle: error ? "error" : null
    }
  );
});
export default RelativeRangeValueInput;
